import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

interface ThemeToggleProps {
  iconSize?: number;
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ iconSize = 20, className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const nextLabel = theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={nextLabel}
      title={nextLabel}
      className={`inline-flex min-h-11 min-w-11 items-center justify-center rounded-full text-content hover:bg-content/10 transition-colors ${className}`}
    >
      {theme === 'dark' ? <Sun size={iconSize} /> : <Moon size={iconSize} />}
    </button>
  );
};

export default ThemeToggle;
